import { TockLogoCore } from './TockLogoCore';
import { computeTockLogoAnchor } from './tockLogoCssDefs';
import Anchor from 'components/Anchor';
import React from 'react';

export interface TockLogoAnchorOnlyProps {
  /**
   * The aria-label for the anchor component
   */
  'aria-label': string;
  /**
   * The href for an anchor component
   */
  href: string;
  /**
   * Click handler for the anchor component (including logo)
   */
  onClick?(): void;
}

export type TockLogoAnchorProps = TockLogoAnchorOnlyProps;

const TockLogoAnchor: React.FunctionComponent<TockLogoAnchorProps> = ({
  'aria-label': ariaLabel,
  href,
  onClick,
  ...rest
}) => (
  <Anchor css={computeTockLogoAnchor} aria-label={ariaLabel} href={href} {...rest}>
    <TockLogoCore />
  </Anchor>
);

export default TockLogoAnchor;
